<ohp-dialog *ngIf="errorDialog"
            [title]="title"
            [subtitle]="subtitle"
            [content]="content"
            [dismissButtonEnabled]="dismissButtonEnabled"
            [lastFocusedElementId]="lastFocusedElementId"
            [componentArea]="area"
            (dismiss)="onDismiss()">
    <div ohpDialogActions>
        <span *ngIf="(isCreateGenericError || isCreateCAPError) && createErrorActionParts" class="create-error-action">
            {{ createErrorActionParts[0] }}
            <a *ngIf="createErrorActionParts.length > 1"
               id="{{ genericActionLinkId }}"
               [attr.href]="fallbackSiteUrl"
               [attr.data-referral]="fallbackSiteReferral"
               [attr.data-area]="area"
               rel="noopener"
               ohpDefaultLinkTarget
               [attr.aria-label]="createActionLinkAriaLabel"
               class="dialog__fallback-link ms-fcl-tda ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a">{{ createErrorActionParts[1] }}</a>{{ createErrorActionParts.length === 3 ? createErrorActionParts[2] : '' }}
        </span>
        <span *ngIf="showFallbackLink && fallbackSiteUrl" class="arrow-link widget-attribution__link">
            <a id="{{ fallbackLinkId }}"
               [attr.href]="fallbackSiteUrl"
               [attr.data-referral]="fallbackSiteReferral"
               [attr.data-area]="area"
               class="ms-fcl-tda ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a"
               rel="noopener"
               ohpDefaultLinkTarget
               [attr.aria-label]="fallbackLinkAriaLabel">
                <span>{{ fallbackLinkText }}</span>
                <ohp-icon-font iconFontName="ArrowRight" size="14" cssClass="link-arrow"></ohp-icon-font>
            </a>
        </span>
        <span *ngIf="errorDialog.onActionClicked || errorDialog.inputText" class="error-dialog__actions">
            <input *ngIf="errorDialog.inputText" #errorInput id="error-dialog-input" type="text" value="{{ errorDialog.inputText }}" readonly>
            <button *ngIf="errorDialog.onActionClicked"
                    id="error-dialog-action-button"
                    class="generic-button ms-bgc-tp ms-fcl-w generic-button--fluent generic-button--fluent--primary generic-button--bordered ms-bgc-w-h ms-bgc-w-a ms-fcl-tp-h ms-fcl-tp-a"
                    (click)="onActionClicked($event)"
                    [attr.aria-label]="actionButtonAriaLabel">
                <span class="generic-button__text">{{ actionButtonTitle }}</span>
            </button>
        </span>
    </div>
    <div ohpDialogFooter>
        <span ohpDialogFooter *ngIf="correlationIdText" class="error-dialog-correlationId"  tabindex="0" contenteditable="true">
            {{ correlationIdText }}
        </span>
    </div>
</ohp-dialog>
